'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _query = require('utilities/query');

var _information = require('./information.html');

var _information2 = _interopRequireDefault(_information);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

exports.default = {
  templateUrl: _information2.default,
  bindings: {
    adverseEvent: '<',
    allowMultipleProducts: '<',
    symptoms: '<',
    locked: '<',
    memberId: '<'
  },
  controller: function () {
    function AdverseEventInformationComponent($http, ToastService) {
      'ngInject';

      _classCallCheck(this, AdverseEventInformationComponent);

      Object.assign(this, {
        $http: $http,
        ToastService: ToastService
      });

      this.today = new Date();
    }

    _createClass(AdverseEventInformationComponent, [{
      key: 'transformChip',
      value: function transformChip(chip) {
        if (_angular2.default.isObject(chip)) {
          return chip;
        }

        return { name: chip, type: 'new' };
      }
    }, {
      key: 'searchSignedProductsByMember',
      value: function searchSignedProductsByMember(searchText) {
        var _this = this;

        return this.$http.get('/odata/ProductOData', {
          params: {
            $select: 'ProductId, ProductName, DateIntroduced, Discontinued',
            $orderby: 'ProductName asc, DateIntroduced desc',
            $filter: 'MemberId eq ' + this.memberId + ' and SignDate ne null and contains(ProductName, \'' + searchText + '\')'
          }
        }).then(function (r) {
          return (0, _query.transformODataResponse)(r).Data;
        }).catch(function (error) {
          return _this.ToastService.showError(error);
        });
      }
    }, {
      key: 'maxProducts',
      get: function get() {
        if (this.allowMultipleProducts) {
          return 100;
        }

        return 2;
      }
    }]);

    return AdverseEventInformationComponent;
  }()
};


// WEBPACK FOOTER //
// ./components/app/adverse-event/information/information.component.js